import React from "react";
import { Navigate, useLocation } from "react-router-dom";

function fallbackPathname(fallback) {
  if (typeof fallback !== "string" || fallback.charAt(0) !== "/") return "/";
  return fallback.split("?")[0] || "/";
}

/**
 * Send a denied user to `fallback`, unless that navigation would stay on the
 * current path (for example `/` denied back to `/`).
 */
export default function RouteFallback({ fallback = "/" }) {
  const location = useLocation();

  if (location.pathname === fallbackPathname(fallback)) {
    return (
      <div role="alert" className="p-6 text-slate-700">
        شما به این بخش دسترسی ندارید.
      </div>
    );
  }

  return <Navigate to={fallback} replace />;
}
